export * from './skyscraper2.component';